import React, { useEffect, useMemo, useState } from "react";
import api from "../../Services/api";
import MenuLateral from "../../Componentes/MenuLateral";
import ListaOcorrenciaAvaliacao from "../../Componentes/ListaOcorrenciaAvaliacao";
import { useNavigate } from "react-router-dom";
import "./styles.css";

const Ocorrencia = () => {
  const [dadosOcorrencias, setDadosOcorrencias] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("usuarioLogado") === null) {
      navigate("/");
    }

    carregaListaOcorrencias();

    const intervaloMenu = setInterval(() => {
      carregaListaOcorrencias();
    }, 60000);

    return () => clearInterval(intervaloMenu);
  }, [navigate]);

  async function carregaListaOcorrencias() {
    const retorno = await buscaOcorrencias();

    if (retorno?.data) {
      const lista = retorno.data[0] || [];

      const detalhadas = await Promise.all(
        lista.map(async (ocorrencia) => {
          try {
            const respDetalhes = await api.get(`/itensocorrencia/${ocorrencia.IDvisita}`);
            if (respDetalhes.data && respDetalhes.data[0]) {
              return {
                ...ocorrencia,
                registro: respDetalhes.data[0].registro,
              };
            }
            return ocorrencia;
          } catch (err) {
            console.error("Erro ao buscar produtos detalhados:", err);
            return ocorrencia;
          }
        })
      );

      setDadosOcorrencias(detalhadas);
      return;
    }

    setDadosOcorrencias([]);
  }

  async function buscaOcorrencias() {
    try {
      return await api.get("/ocorrencia/avaliacao");
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  const resumo = useMemo(() => {
    return dadosOcorrencias.reduce(
      (acc, item) => {
        acc.total += 1;
        acc.valor += Number(item.valor || 0);
        acc.produtos += item.registro?.reduce((registroAcc, reg) => {
          return registroAcc + (reg.Produtos?.length || 0);
        }, 0) || 0;
        return acc;
      },
      { total: 0, valor: 0, produtos: 0 }
    );
  }, [dadosOcorrencias]);

  const valorTotal = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(resumo.valor || 0);

  return (
    <div className="menu-container-ocorrencia">
      <MenuLateral />

      <div id="painel_principal_ocorrencia">
        <div className="ocorrencia-page-header">
          <div className="ocorrencia-page-title-wrap">
            <div className="ocorrencia-page-title-row">
              <span className="ocorrencia-page-kicker">Ocorrências</span>
              <h1 className="ocorrencia-page-title">Ocorrências não avaliadas</h1>
              <span className="ocorrencia-page-badge">{dadosOcorrencias.length}</span>
            </div>
          </div>
        </div>

        <div className="ocorrencia-summary-grid">
          <div className="ocorrencia-summary-card">
            <span>Ocorrencias pendentes</span>
            <strong>{resumo.total}</strong>
            <small>Aguardando avaliacao manual</small>
          </div>
          <div className="ocorrencia-summary-card">
            <span>Valor envolvido</span>
            <strong>{valorTotal}</strong>
            <small>Soma das visitas exibidas</small>
          </div>
          <div className="ocorrencia-summary-card">
            <span>Produtos nos registros</span>
            <strong>{resumo.produtos}</strong>
            <small>Total de itens detalhados</small>
          </div>
        </div>

        <div id="div_painel_ocorrencia">
          <div className="ocorrencia-section-header">
            <span className="ocorrencia-section-kicker">Fila de avaliacao</span>
            <h2 className="ocorrencia-section-title">Analise e aprove as ocorrencias</h2>
          </div>

          <ListaOcorrenciaAvaliacao
            lista={dadosOcorrencias}
            onAtualizarLista={carregaListaOcorrencias}
          />
        </div>
      </div>
    </div>
  );
};

export default Ocorrencia;
